import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { LiveProgramForm } from '../forms/LiveProgram/LiveProgramForm';

export type LiveProgramEditorState = {
  liveProgramForm: LiveProgramForm;
  formLoading: boolean;
  hasErrors: false;
};

export const initialState: LiveProgramEditorState = {
  liveProgramForm: new LiveProgramForm(),
  formLoading: false,
  hasErrors: false,
};

const liveProgramEditorSlice = createSlice({
  name: 'LiveProgramEditor',
  initialState,
  reducers: {
    UpdateForm: (state, action: any) => {
      // console.log('UpdateForm', { state, action });
      state.liveProgramForm = action.payload;
      state.formLoading = false;
    },
    CreateForm: (state, action: any) => {
      state.liveProgramForm = action.payload;
      state.formLoading = false;
    },
  },
  extraReducers: {},
});

export const { UpdateForm, CreateForm } = liveProgramEditorSlice.actions;

// export ouAdminEditorSlice selector to get the slice in any component
export const liveProgramEditorSliceSelector = (state: RootState) => state.liveProgramEditor;
// export The reducer
const liveProgramEditorReducer = liveProgramEditorSlice.reducer;

export default liveProgramEditorReducer;
